import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button,
  Box,
  Flex,
  HStack,
  IconButton,
  useDisclosure,
  Stack,
  Link,
  Image,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import logo from "../../assets/logo.svg"; // dein Logo-Pfad

const Navbar = () => {
 const { isOpen, onOpen, onClose } = useDisclosure();
 const navigate = useNavigate();
 const handleLogout = async () => {
   await axios.get(`${window.location.origin}/api/logout.php`, { withCredentials: true }); 
   navigate("/login");
  };
  return (
    <Box
      bgGradient="linear(to-r, teal.500, blue.400)"
      px={4}
      py={3}
      color="white"
      shadow="md"
      position="sticky"
      top="0"
      zIndex="1000"
    >
      <Flex h={16} alignItems="center" justifyContent="space-between">
        {/* Logo */}
        <HStack spacing={3} alignItems="center">
          <Image
            src={logo}
            alt="Logo"
            boxSize="40px"
            objectFit="contain"
            borderRadius="md"
          />
          <Link
            as={RouterLink}
            to="/"
            fontWeight="bold"
            fontSize={{ base: "lg", md: "xl" }}
            _hover={{ textDecoration: "none" }}
          >
            Ideenverwaltung
          </Link>
		  
        </HStack>

        {/* Hamburger Button (mobil) */}
        <IconButton
          size="md"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Menü öffnen"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
          variant="ghost"
          color="white"
          _hover={{ bg: "whiteAlpha.200" }}
        />

        {/* Navigation links (Desktop) */}
        <HStack spacing={6} display={{ base: "none", md: "flex" }}>
          <Link as={RouterLink} to="/ideen" _hover={{ color: "whiteAlpha.800" }}>
            Ideen
          </Link>
          <Link
            as={RouterLink}
            to="/ideen/addIdee"
            _hover={{ color: "whiteAlpha.800" }}
          >
            Neue Idee
          </Link>
		 <Button size="sm" variant="ghostOutline" onClick={handleLogout}>Logout</Button>  
        </HStack>
      </Flex>

      {/* Mobile Menü */}
      {isOpen ? (
        <Box pb={4} display={{ md: "none" }}>
          <Stack as="nav" spacing={4}>
            <Link as={RouterLink} to="/ideen" onClick={onClose}>
              Ideen
            </Link>
            <Link as={RouterLink} to="/ideen/addIdee" onClick={onClose}>
              Neue Idee
            </Link>
			<Button size="sm" variant="ghostOutline" onClick={handleLogout}>Logout</Button>
          </Stack>
        </Box>
      ) : null}
    </Box>
  );
};

export default Navbar;
